var socialLoginModal = true;
var owlCarousel;
$(document).ready(function ($) {
    var gtag_input = $('#l2dPDUzAv8dqYRs4z3BOpeIg3IDkqhFP');
    if (window.requestIdleCallback) {
        requestIdleCallback(function () {
            if(gtag_input.length && gtag_input.data('gtagconfig')) {
                updateGtagConfig();
            }
        });
    } else {
        setTimeout(function () {
            if(gtag_input.length && gtag_input.data('gtagconfig')) {
                updateGtagConfig();
            }
        }, 500);
    }

    var windowWidth = $('.single-job .container').width();
    $('.single-job .container .old-header').height(windowWidth/4.24);
    $(window).resize(function(){
        windowWidth = $('.single-job .container').width();
        $('.single-job .container .old-header').height(windowWidth/4.24);
    });

    $('body').on('click', '.cancelBtnForJobAlert', function () {
        $(this).attr("disabled", true);
    });
    $('.featuredJobsTab').hide();

    $('.recentJobsTab').show();

    $('.featuredJobs').on('click', function () {
        $('.featuredJobsTab').show();
        $('.recentJobsTab').hide();
    });

    $(document).on('click', '.recentJobs', function () {
        $('.recentJobsTab').show();
        $('.featuredJobsTab').hide();
    });

    $(document).on('click', '.addJobAlertBtn', function (e) {
        var id = $(this).attr('data-id');
        var lang = $(this).attr('data-lang');
        var href = $(this).attr('href');
        $.get(href, function (data) {
            $('#addJobAlert').modal('show')
                    .find('.modal-content')
                    .html(data);
        });

        e.preventDefault();
    });
    $('.scrollTotrainingDetails').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#job-post").offset().top
        }, 500);
    });
    $('.scrollToParticipations').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#participation").offset().top
        }, 500);
    });
    $('.scrollToAboutTrainingOrganizer').on('click', function () {
        $('html, body').animate({
            scrollTop: $("#company-details").offset().top
        }, 500);
    });
    $('.addJobAlertButton').on('click', function () {
        $('.jobAlertFormContainer').removeClass('hide');

        $('html, body').animate({
            scrollTop: $(".jobAlertFormContainer").offset().top
        }, 500);
    });

    $(document).on('click', '.cancelBtnForJobAlert', function () {
        $('#follow_modal').modal('hide');
    });

    (function () {
        var $textBox = $('<input class="textbox" type="text" name="Users[first_name]" />');
        $('*[data-edit="text"]').click(function () {
            var $elem = $(this);

            $elem.hide();
            $elem.after($textBox);

            $textBox.val($elem.text()).focus();
            $textBox.blur(function () {

                $elem.text($(this).val());
                $(this).val('').remove();
                $elem.show();

            });
        });
    })();

    $('.deactivationSubmitBtn').on('click', function () {
        var userId = $(this).attr('data-id');
        window.location.href = '/users/user/deactivate/' + userId;
    });

    $('.deleteNotificationSubmitBtn').on('click', function () {
        var itemId = $(this).attr('data-id');
        window.location.replace('/users/notifications/delete/' + itemId);
    });

    $('.notificationDeleteBtn').on('click', function () {
        var itemId = $(this).attr('data-id');
        $('#myModal').modal('show');

        $('.deleteNotificationSubmitBtn').on('click', function () {
            window.location.replace('/users/notifications/delete/' + itemId);
        });
    });

    $('.applicantDeleteBtn').on('click', function () {
        var itemId = $(this).attr('data-id');
        $('#myModal').modal('show');

        $('.deleteSubmitBtn').on('click', function () {
            window.location.replace('/users/user/delete-applicant/' + itemId);
        });
    });


    var itemsBlock;
    var body = $('body');

    var options = {
        url: "/companies/companies/get-companies",
        getValue: function (element) {
            return element.name;
        },
        list: {
            match: {
                enabled: true
            }
        },
        theme: "square"
    };

    $('[data-toggle="tooltip"]').tooltip();


    $(".test").on('click', function (e) {
        e.preventDefault();
    });

    $(".asd").easyAutocomplete(options);

    $(document).on('click', '.no-user', function (e) {
        $('#modalView').modal('show');

        e.preventDefault();
    });

    $(".dial").knob({
        'change': function (v) {
        }
    });

    $('.dial').trigger(
            'configure',
            {
                "fgColor": "#FF0000",
                "skin": "tron",
                "displayInput": false,
            }
    );

    $(".edit-profile-left-bar-menu").find("a[href*='" + window.location.pathname + "']").parent("li").addClass("sidebar-active");

    function performClick(elemId) {
        var elem = document.getElementById(elemId);
        if (elem && document.createEvent) {
            var evt = document.createEvent("MouseEvents");
            evt.initEvent("click", true, false);
            elem.dispatchEvent(evt);
        }
    }

    $(document).on("click", ".file-preview-image", function (e) {
        performClick('userUploadImage');
    });

    $(".side-menu").find("a[href*='" + window.location.pathname + "']").parent("li").addClass("active");

    $('.panel-collapse').has('.active').addClass('in');
    $('.navbar-toggle').click(function () {
        $('.navbar-nav').toggleClass('slide-in');
        $('.side-body').toggleClass('body-slide-in');
        $('#search').removeClass('in').addClass('collapse').slideUp(200);
    });

    $('.priceBtn').on('click', function () {
        var href = $(this).attr('data-href');
        window.location.replace(href)
    });



    var currency = $('.currency');

    currency.each(function (index) {
        var a = $(this).text();
        a = a.replace(new RegExp("^(\\d{" + (a.length % 3 ? a.length % 3 : 0) + "})(\\d{3})", "g"), "$1 $2").replace(/(\d{3})+?/gi, "$1 ").trim();
        var sep = ",";
        a = a.replace(/\s/g, sep);
        $(this).text(a);
    })

    var pageContent = $('.hs_page_content');


    /* Open follow edit popup */
    $(pageContent).on('click', '.follow_card_item', function (evt) {

        if(evt.target.tagName !== 'IMG') {
            var data = {id: $(this).data('id')};
            if($(this).data('token')) {
                data['token'] = $(this).data('token');
            }
            openFollowModal(data, $(this).data('parent'));
        }

    });

    $('body').on('click', '#btn_add_subscription, #btn_add_subscription_from_jobs_list', function () {

        if(parseInt($(this).attr('limited')) === 1) {
            var url = $(this).attr('data-href');
            $('#main-modal').modal('show')
                    .find('.modal-content')
                    .load(encodeURI(url));
        }
        else {
            if($(this).attr('id') === 'btn_add_subscription_from_jobs_list') {
                openFollowModal({'from': 'jobs_list'}, null);
            }
            else {
                openFollowModal({}, null);
            }
        }
    });

    /* Follow type click */
    $(document).on('click', '.select_follow_type', function () {

        orderFollowBlocks($(this).data('parent'));
        initFollowTypeSelect2();

        $('#follow_modal').find('#parent').val($(this).data('parent'));

        $('#choose_parent_block').hide();
        $('#alert_form').show();


    });

    /* Following button hover */
    $("#search_list_block, #follow-block, #company_follow_block, .active-job-carousel").on("mouseover", ".btn_following", function () {
        $(this).addClass('hs_unfollow');
        $(this).find('.following_text').text($(this).data('unfollow'))
    });

    $("#search_list_block, #follow-block, #company_follow_block, .active-job-carousel").on("mouseleave", ".btn_following", function () {
        $(this).removeClass('hs_unfollow');
        $(this).find('.following_text').text($(this).data('following'))
    });
    /* Saving button hover */
    $("#follow-block").on("mouseover", ".job_save", function () {
        $(this).addClass('hs_unsave');
        $(this).find('.unsaving_text').text($(this).data('cancel'))
    });

    $("#follow-block").on("mouseleave", ".job_save", function () {
        $(this).removeClass('hs_unsave');
        $(this).find('.unsaving_text').text($(this).data('saved'))
    });

    function startCarousel(){
        $("#company_active_job_carousel").trigger('destroy.owl.carousel').removeClass('owl-loaded');

        return $("#company_active_job_carousel").owlCarousel(
                {
                loop:true,
                items:4,
                margin:10,
                responsiveClass:true,
                responsive:{
                    0:{
                        items:1,
                        nav:false
                        },
                    580:{
                        items:2,
                        nav:false
                        },
                    768:{
                        items:2,
                        nav:true
                        },
                    1200:{
                        items:3,
                        nav:true,
                        loop:true
                        }
                    },
                    nav: true,
                    navText: [
                        '<i class="fa fa-angle-left hs_left_btn" aria-hidden="true"></i>',
                        '<i class="fa fa-angle-right hs_right_btn" aria-hidden="true"></i>'
                    ]
                });
    }
    function refreshCarousel($owl) {
        $owl.trigger('refresh.owl.carousel');
    }


    var tab_title = $('#hs_user_top_menu').find('.user_top_menu.active').data('title');

    /* User menu item click */
    $('.user_top_menu').on('click', function () {
        $('.loading_pop_up').show();
        var self = $(this);
        var url = self.data('href');
        var from_profile_edit = 0;
        if(tab_title === 'edit profile'){
            from_profile_edit = 1;
        }
        tab_title = self.data('title');
        var urlPath = url.substring(3, url.length);

        $.ajax({
            url: url,
            type: 'GET',
            data: {'from_profile_edit' : from_profile_edit},
            success: function( response ){

                $(".hs_page_content").html(response.content);
                document.title = $(".hs_page_content").find('#seo_title').val();
                if(Object.keys(response).indexOf('profile_data_content') !== -1) {
                    $("#hs_main_info_block").html(response.profile_data_content);
                }
                if(Object.keys(response).indexOf('header') !== -1) {
                    $("#hs_main_info_block").html(response.header);
                }
                $('.user_top_menu').each(function () {
                    if($(this).hasClass('active')) {
                        $(this).removeClass('active');
                    }
                });
                self.addClass('active');

                if(self.hasClass('default_item')) {
                    $('.only_userProfile_block').removeClass('hidden');
                    $('.hs_page_content ').addClass('view_edit_profile_content');
                }
                else {
                    $('.only_userProfile_block').addClass('hidden');
                    $('.hs_page_content ').removeClass('view_edit_profile_content');
                }

                $('#log-in-header').find('#lang-dropdown ul li a').each(function () {
                    var langLocal = $(this).attr('href').substring(0, 3);
                    $(this).attr('href', langLocal + urlPath);

                });
                window.history.pushState({url: "" + url + ""}, self.data('title'), url);
                $('.loading_pop_up').hide();
            },
        });

    });

    /* reload content after pushState using */
//    $(window).bind('popstate', function(){
//        window.location.href = window.location.href;
//    });

    /* Open user update modal */
    $(document).on('click', '.btn_add_block_info, .btn_edit_block_info, .btn_child_edit, .invite_friend_block', function () {

        var self = $(this);
        $('.loading_pop_up').show();
        $.ajax({
            url: $(this).data('url'),
            data: {is_volunteer: $(this).data('volunteer')},
            type: 'GET',
            success: function( response ){
                var modalBody = $('#user_info_update_modal .modal-body');
                modalBody.html(response);
                //to do remove this shit
                setTimeout(function(){
                    $('#add_hard_skill').click();
                    $('.remove-skill').last().click();
                    $('#user_info_update_modal').modal('show');
                    $('.loading_pop_up').hide();
                }, 100);


                if($('#softskillsform-skills').length) {
                    var selected_soft_skills_length = $('#softskillsform-skills').val() ? $('#softskillsform-skills').val().length : 0;
                    var requested_soft_skills_length = $('#new_soft_skills_container').find('.skills-delete-container').length;
                    var sum_soft_skills_length = selected_soft_skills_length + requested_soft_skills_length;
                    initSelect2('#softskillsform-skills', 10-requested_soft_skills_length, $('#softskillsform-skills').attr('errormsg'));
                    if(sum_soft_skills_length == 10){
                        $('#request_new_soft_skill_text').addClass('hidden');
                    }
                }
                if(self.attr('data-ion-slider')) {
                    initIonSlider(!$('#hs_lang_block').find('.lang_proficiency_block').length);
                }

                if(self.attr('data-ion-skill')) {
                    initSkillIonSlider();
                }

                if(self.data('employment')) {
                    initTitleAutoComplete();
                }

                $('[data-toggle="popover"]').popover();
                $('body').find('.copy_link_icon').tooltip({
                    disabled: true
                });

            }
        });


    });

    /* Submit update form */
    $(document).on('submit', '.update_info_form', e => {
        e.preventDefault();
        const self = $(e.currentTarget);
        self.find('.form_button_block').find('button').attr('disabled', true);
        self.find('.form_button_block').find('.btn_submit_form').append('<i class="ml5 fa fa-spinner fa-spin"></i>');
        self.addClass('frozen');
        $.ajax({
            url: self.attr('action'),
            type: 'post',
            data: self.serialize(),
            success: response => {
                let type = 'error';
                if(response.success) {
                    const updatedContent = $('#' + self.data('content'));
                    const template_id = self.data('tpl');
                    if(template_id){
                        const template = _.template($(template_id).html());
                        updatedContent.html(template({data: response}));
                    }
                    else {
                        updatedContent.html(response.content);
                        if(response.content) {
                            updatedContent.parent().find('.not_content_text').addClass('hidden');
                            updatedContent.next('span').html('<i class="fa fa-pencil" ></i>');
                            updatedContent.next('span').removeClass('btn_add_block_info').addClass('btn_edit_block_info');
                        }
                        else {
                            updatedContent.parent().find('.not_content_text').removeClass('hidden');
                            updatedContent.next('span').html('<i class="fa fa-plus" ></i>');
                            updatedContent.next('span').addClass('btn_add_block_info').removeClass('btn_edit_block_info');
                        }
                    }

                    type = 'success';
                    reloadParentWindow();
                    $('#user_info_update_modal').modal('hide');
                }
                self.find('.form_button_block').find('button').attr('disabled', false);
                self.find('.form_button_block').find('.btn_submit_form i.fa-spinner.fa-spin').remove();
                self.removeClass('frozen');
                updateCompleteness(response.completeness, false);
                showNotification(response.message, type);

            }
        });

    });

    /* user info update */
    $(document).on('submit', '.rel_user_update', e => {
        e.preventDefault();
        const self = $(e.currentTarget);
        const removed_new_soft_skills = $('#new_soft_skills_container').find('.skills-delete-container.removed.hidden');
        let removed_new_soft_skills_ids_array = [];
        removed_new_soft_skills.each(function(key, value){
            removed_new_soft_skills_ids_array.push($(value).find('.remove-new-soft-skill').data('id'));
        });
        $('input[name="removed_requested_soft_skills"]').val(removed_new_soft_skills_ids_array.join(','));
        const removed_new_hard_skills = $('.skill.row.requested_hard_skills.removed.hidden');
        let removed_new_hard_skills_ids_array = [];
        removed_new_hard_skills.each(function(key, value){
            removed_new_hard_skills_ids_array.push($(value).find('.remove-new-hard-skill').data('id'));
        });
        $('input[name="removed_requested_hard_skills"]').val(removed_new_hard_skills_ids_array.join(','));
        self.find('.form_button_block').find('button').attr('disabled', true);
        self.find('.form_button_block').find('.btn_submit_form').append('<i class="ml5 fa fa-spinner fa-spin"></i>');
        self.addClass('frozen');
        $.ajax({
            url: self.attr('action'),
            type: 'post',
            data: self.serialize(),
            success: response => {
                let type = 'error';
                if(response.success) {
                    const keys  = Object.keys(response);
                    if(keys.indexOf('show_add_btn') !== -1){
                        if(!response.show_add_btn){
                            $('#hs_reference_block').find('.btn_add_block_info').addClass('hidden');
                        }
                    }
                    const template = _.template($(self.data('tpl')).html());
                    $(self.data('block')).parent().find('.not_content_text').addClass('hidden');
                    if (self.data('list-item')) {

                        const subTemplate = _.template($(self.data('sub-tpl')).html());
                        const itemBlock = $(self.data('block')).find('div[data-id=' + response.data.id + ']');
                        if (itemBlock.length) {
                            itemBlock.html(subTemplate({data: response.data}));
                            if (itemBlock.hasClass('empty_data')) {
                                itemBlock.removeClass('empty_data');
                            }
                        }
                        else {
                            $(self.data('block')).prepend(template({data: response.data, renderSub: subTemplate}));
                        }
                    }
                    else {
                        if(keys.indexOf('currency') !== -1 && keys.indexOf('job_type_name') !== -1 && keys.indexOf('city') !== -1) {
                            $(self.data('block')).html(template({data: response.data, salary_currency: response.currency, job_type_name: response.job_type_name, city: response.city}));
                        }
                        else {
                            $(self.data('block')).html(template({data: response.data}));
                        }
                        if(!response.data || !response.data.length){
                            $(self.data('block')).parent().find('.not_content_text').removeClass('hidden');
                        }

                    }
                    if(keys.indexOf('requestedSkills') !== -1){
                        $(self.data('new_block')).empty();
                        if (response.requestedSkills.length) {
                            $(self.data('new_block')).html(template({data: response.requestedSkills, type: 'new_skill'}));
                            $('[data-toggle="popover"]').popover();
                        }
                        if(!response.requestedSkills.length && !response.data.length){
                            $(self.data('block')).parent().find('.not_content_text').removeClass('hidden');
                        }
                    }
                    type = 'success';
                    reloadParentWindow();
                    $('#user_info_update_modal').modal('hide');
                }
                if(response.completeness) {
                    let updateAllCompleteness = true;
                    if (self.data('list-item')) {
                        updateAllCompleteness = false;
                    }
                    updateCompleteness(response.completeness, updateAllCompleteness);
                }
                showNotification(response.message, type);
                self.find('.form_button_block').find('button').attr('disabled', false);
                self.find('.form_button_block').find('.btn_submit_form i.fa-spinner.fa-spin').remove();
                self.removeClass('frozen');

            }
        });

    });


    /* delete education or work experience */
    $('body').on('click', '.delete_list_item', function (e) {

        e.preventDefault();

        var self = $(this);
        self.closest('.form_button_block').find('button').attr('disabled', true);
        self.append('<i class="ml5 fa fa-spinner fa-spin"></i>');
        $.ajax({
            url: self.data('url'),
            success: function (response) {
                var type = 'error';
                if(response.success) {
                    var blockSelector = $(self.data('block'));
                    blockSelector.find('div[data-id=' + response.id + ']').remove();
                    var keys = Object.keys(response);
                    if(keys.indexOf('show_add_btn') !== -1){
                        if(response.show_add_btn){
                            $('#hs_reference_block').find('.btn_add_block_info').removeClass('hidden');
                        }
                    }
                    type = 'success';
                    if(!blockSelector.find('.accordion_block_list_item').length){
                        blockSelector.parent().find('.not_content_text').removeClass('hidden');
                    }
                    reloadParentWindow();
                }

                showNotification(response.message, type);

                if(response.completeness) {
                    updateCompleteness(response.completeness, false);
                }

                $('#user_info_update_modal').modal('hide');

            }
        });

    });

    $(document).on('click', '.btn_delete_item', function (e) {
        e.stopPropagation();
        var url = $(this).attr('data-url');
        var blockId = $(this).closest('.hs_content_block').data('id');
        itemsBlock = $('#' + blockId);
        $('#confirm_modal').modal('show');
        $('#confirm_modal .btn_confirm_action').data('url', url);
    });
    $('.btn_confirm_action').on('click', function () {
        var url = $(this).data('url');
        $.ajax({
            url: url,
            success: function (response) {
                var type = 'error';
                    if(response.success) {

                        if(response.id) {
                            $('.hs_content_block').find('div[data-id='+response.id+']').remove();
                    } else {
                        itemsBlock.html('');
                    }

                    type = 'success';
                }

                showNotification(response.message, type);
            }
        });
        $(this).closest('.modal').modal('hide');

    });
    /* Profile Settings form submit */
    $(pageContent).on('submit', '.profile_settings_form', function (e) {
        $("#edit-password-form").addClass("hide");
        e.preventDefault();
        var self = $(this);
        var submitButton = self.find('.btn_submit_form');
        submitButton.append('<i class="spin_icon ml5 fa fa-spinner fa-spin"></i>');

        $.ajax({
            url: self.attr('action'),
            type: 'post',
            data: self.serialize(),
            success: function (response) {
                var type = 'error';
                if(response.success) {
                    type = 'success';
                }

                if(self.data('password-change')) {
//                    $(".profile_settings_form").addClass("hide");
                    $('#edit-password-btn').removeClass('hide');
                    var change_password_text_container = $('#change_password_text_container');
                    change_password_text_container.find('.password_change_title').text(self.data('change_password'));
                    change_password_text_container.find('.password_change_text').text(self.data('change_password_text'));

                }

                submitButton.find('.spin_icon').remove();
                showNotification(response.message, type);


            }
        });

    });

    /* Change password block toggle */
    $(pageContent).on('click', '#edit-password-btn', function (e) {
        e.preventDefault();
        $(this).addClass("hide");
        $("#edit-password-form").removeClass("hide");

    });

    $(pageContent).on('click', '.cancel-password-edit', function (e) {

        e.preventDefault();
        $("#edit-password-form").addClass("hide");
        $("#edit-email-form").addClass("hide");
        $("#edit-email-btn").removeClass("hide");
        $("#edit-password-btn").removeClass('hide');

    });
    $("#edit-email-form").addClass("hide");
    $(pageContent).on('submit', '.email_change_form', function (e) {

        e.preventDefault();
        var self = $(this);
        var submitButton = self.find('.btn_submit_form');
        submitButton.append('<i class="spin_icon ml5 fa fa-spinner fa-spin"></i>');

        $.ajax({
            url: self.attr('action'),
            type: 'post',
            data: self.serialize(),
            success: function (response) {
                var type = 'error';
                if(response.success) {
                    type = 'success';
                }
                if(self.data('change_email')) {
                    $('#edit-email-btn').removeClass('hide');
                    $('#edit-email-form').addClass('hide');
                    var change_email_text_container = $('#change_email_text_container');
                    change_email_text_container.find('.email_change_title').text(self.data('change_email'));
                    change_email_text_container.find('.email_change_text').text(self.data('change_email_text'));

                }
                submitButton.find('.spin_icon').remove();
                showNotification(response.message, type);
            }
        });

    });

    $(pageContent).on('click', '#edit-email-btn', function (e) {
        e.preventDefault();
        $(this).addClass("hide");
        var pass = $(this).data('pass');
        if (pass != 1){
            $("#edit-password-form").removeClass("hide");
            $("#edit-password-btn").addClass("hide");
        }
        $("#edit-email-form").removeClass("hide");

    });
    $(pageContent).on('click', '.cancel-email-edit', function (e) {

        e.preventDefault();
        $("#edit-email-form").addClass("hide");
        $("#edit-email-btn").removeClass('hide');

    });
    /* job alert form submit */
    $(document).on('submit', '#job-alerts-form', function (e) {
        e.preventDefault();
        var self = $(this);
        var error_message_block = self.find('#error_message_block');
        error_message_block.empty().hide();
        self.find('.alert_block_buttons').find('button').attr('disabled', true);
        self.find('.alert_block_buttons').find('.submit').append('<i class="ml5 fa fa-spinner fa-spin"></i>');
        self.addClass('frozen');

        $.ajax({
            url: self.attr('action'),
            type: 'post',
            data: self.serialize(),
            success: function (response) {
                if(response.success) {

                    if(self.data('from') === 'jobs_list'){
                        var categories_ids = [], companies_ids = [];
                        var response_categories = response.data.categories;
                        var response_companies = response.data.companies;
                        for(var i = 0; i < response_categories.length; i++){
                            categories_ids.push(parseInt(response_categories[i]['struct_id']));
                        }
                        for(var j = 0; j < response_companies.length; j++){
                            companies_ids.push(parseInt(response_companies[i]['struct_id']));
                        }
                        $('.web_item_card').find('.btn_follow_block').each(function(key, value){
                            var template = _.template($('#tpl_following_button').html());
                            var btn_follow = $(value).find('.btn-follow');
                            var btn_companyid = btn_follow.data('companyid');
                            var btn_alertId = self.data('alertId');
                            var btn_categoryid = btn_follow.data('categoryid');
                            if(btn_companyid && companies_ids.indexOf(btn_companyid) !== -1 || btn_categoryid && categories_ids.indexOf(btn_categoryid) !== -1){
                                $(value).html(template({companyId : btn_companyid, categoryId:btn_categoryid}));
                            }
                        });
                    }
                    else {
                        var template = _.template($(self.data('tpl')).html());
                        var subTemplate = _.template($(self.data('sub-tpl')).html());
                        var alertsBlock = $('.subscribe_item_body .list-view');

                        if (alertsBlock.length) {
                            if (alertsBlock.find('div[data-id=' + response.data.id + ']').length) {
                                alertsBlock.find('div[data-id=' + response.data.id + ']').html(subTemplate({data: response.data}))
                            } else {
                                alertsBlock.prepend(template({data: response.data, renderSub: subTemplate}));
                            }
                        } else {
                            $('.subscribe_item_body').html('<div class="list-view" >' + template({
                                data: response.data,
                                renderSub: subTemplate
                            }) + '</div>');
                            $('.subscription_block').find('.card_header').removeClass('no_display');
                        }
                    }

                    if(parseInt($('.subscribe_item_body').find('.follow_card_item').length) === parseInt($('#create_alert_url').data('limit'))) {
                        $('#btn_add_subscription').attr('data-href', $('#limit_alert_url').data('url')).attr('limited', 1)
                    }

                    $('#follow_modal').modal('hide');
                    showNotification(response.message, 'success');

                }
                else {
                    error_message_block.text(response.message);
                    self.find('.alert_block_buttons').find('button').removeAttr('disabled');
                    self.find('.alert_block_buttons').find('.submit .fa-spinner.fa-spin').remove();
                    self.removeClass('frozen');
                    error_message_block.show();
                }




            }
        });

    });

    /* Delete job alert */
    $(document).on('click', '.alertDeleteBtn', function () {
        var url = $(this).attr('data-url');
        $('#myModal').modal('show');

        $('.deleteAlertSubmitBtn').on('click', function () {

            $.ajax({
                url: url,
                success: function (response) {
                    var type = 'error';
                    if(response.success) {

                        if(response.id) {
                            $('.subscribe_item_body').find('div[data-id='+response.id+']').remove();
                            if(parseInt($('.subscribe_item_body').find('.follow_card_item').length) < parseInt($('#create_alert_url').data('limit'))) {
                                $('#btn_add_subscription').attr('data-href', $('#create_alert_url').data('url')).attr('limited', 0)
                            }
                        }

                        type = 'success';
                    }

                    showNotification(response.message, type);
                }
            });
            $(this).closest('.modal').modal('hide');

        });
    });

    /* Change Cv language click */
    body.on('click', '.cv_lang_tab', function () {

        $('.cv_lang_tab').removeClass('active');
        $(this).addClass('active');
        $('.loading_pop_up').show();
        var cv_lang = $(this).data('id');
        $.ajax({
            url: $(this).data('url'),
            type: 'post',
            data: {cv_lang: cv_lang},
            success: function (response) {
                if(response.header) {
                    $("#hs_main_info_block").html(response.header);
                }

                $(".hs_page_content").html(response.content);
                $('.loading_pop_up').hide();
                var user_profile_image = $('#profile_image_block');
                user_profile_image.find('.change_image_text').addClass('hidden');
                user_profile_image.find('.change_image_text.lang_id_' + cv_lang).removeClass('hidden');

            }
        });

    });


    /* Notification link click event */
    $(pageContent).on('click','.notify_action_link a', function (e) {

        var notifyCardItem = $(this).closest('.notification_card_item');

        $.ajax({
            url: $(this).data('url'),
            type: 'GET',
            success: function (response) {
                notifyCardItem.removeClass('not_seen');
            }
        });

    });

    /* Doc file warning message */
    $(body).on('change', '#applyasguestform-cv', function () {

        var extension = $(this).val().split('.').pop();
        if(extension === 'docx' ) {
            $(body).find('#doc_file_warning').removeClass('no_display');
        }
        else {
            $(body).find('#doc_file_warning').addClass('no_display');
        }


    });

    body.on('click', function(e){
        if($(e.target).parents('.select2.select2-container').prev('#softskillsform-skills').length || $(e.target).hasClass('disable-select2-message')) {
            if ($('#softskillsform-skills').is(':disabled')) {
                $('#select2_error_message').removeClass('hidden');
            }
        }
        else {
            $('#select2_error_message').addClass('hidden');
        }
    });

    /* Update user privacy */
    body.on('click', '#btn_update_privacy', function () {

        $.ajax({
            url: $(this).data('url'),
            type: 'POST',
            data: {is_private: $('input[name=is_private]:checked').val()},
            success: function (response) {
                if(response.success) {
                    $('#hs_update_modal_body').find('.modal-body').html(response.html);
                }
                else {
                    $('#user_info_update_modal').modal('hide');
                }
            }
        });

    });

    //View more media
    $('#hs_company_more_media_btn').on('click', function () {
        var toggleText = $(this).attr('data-toggle');
        $(this).attr('data-toggle', $(this).text()).text(toggleText);
        $('.view_more_item').slideToggle();
    });

    //open guest apply modal
    body.on('click', '.hs_send_cv_btn', function () {
        var self = $(this);
        var data = {
            company_id: self.data('company-id'),
            company_title: self.data('company-title'),
            job_id: self.data('job-id'),
            job_title: self.data('job-title'),
        };

        $.ajax({
            url: self.data('url'),
            type: 'GET',
            data: data,
            success: function (response) {
                $('#hs_default_modal').find('.modal-body').html(response.content);
                $('#hs_default_modal').modal('show');
            }
        });
    });

    /* Communication form submit  */
    $(pageContent).on('submit', '#preferred_communication_form', function (e) {

        e.preventDefault();
        var self = $(this);
        var submitButton = self.find('.btn_submit_form');
        submitButton.append('<i class="spin_icon ml5 fa fa-spinner fa-spin"></i>');
        var data = {};
        $('.pref_communication').each(function () {
            if($(this).is(':checked')) {
                data[$(this).val()] = 1;
            }
            else {
                data[$(this).val()] = 0;
            }
        })

        $.ajax({
            url: self.attr('action'),
            type: 'post',
            data: {communication: data},
            success: function (response) {
                var type = 'error';
                if(response.success) {
                    type = 'success';
                }

                submitButton.find('.spin_icon').remove();
                showNotification(response.message, type);

            }
        });

    });

    /*social login modal close event*/
    $('#social_login_modal').on('hidden.bs.modal', function () {
        $(this).find('.modal-content').html('');
        if(socialLoginModal) {
            $.ajax({
                type: 'POST',
                url: $('#hs_update_step_url').val(),
                data: {step: $('#hs_social_type').data('step')},
                success: function (response) {

                }
            });
        }
    });

    /* Guest follow communication type */
    body.on('click', '.hs_com_method_follow_check', function () {
       if($(this).is(':checked')) {
           $('#'+$(this).data('block')).removeClass('no_display')
       }
       else {
           $('#'+$(this).data('block')).addClass('no_display')
       }
    });
    if (window.location.hash === '#open-subscribe-modal'){
        loadProductSubscrieModal();
    }
    
    /* Follow button click */
    body.on("click", ".hs_follow_btn", function(e) {
        $('.loading_pop_up').show();
        $.ajax({
            type: 'POST',
            url: $(this).data('url'),
            success: function (response) {
                var followModal = $('#subscribe-modal');
                followModal.find('.modal-body').html(response.content);
                $('.loading_pop_up').hide();
                followModal.modal('show');
            }
        });
        return false;
    });

    /* Follow modal submit */
    body.on("submit", "#subscription-form", function (e) {
        e.preventDefault();

        var $this = $(this);

        $.ajax({
            url: $this.attr('action'),
            type: 'post',
            data: $this.serialize(),
            success: function (response) {
                $this.closest('.modal').modal('hide');
                var type = 'error';

                if (response.success) {
                    type = 'success';

                    if (response.type === 'job') {
                        if (typeof gtag == 'function') {
                            gtag('event', 'follow_job');
                        }
                    }

                    if (response.job_list) {
                        $('.hs_job_list_item').each(function () {
                            var dataId = $(this).attr('data-id');
                            if (response.follow_jobs[dataId]) {
                                $(this).find('.btn_follow_block').html(response.follow_jobs[dataId]);
                            }
                        })
                    } else {
                        if (response.type == 'company') {
                            $('div[data-id='+response.data_id+']').find('.btn_follow_block').html(response.button);
                        } else if(response.type == 'category') {
                            setTimeout(() => {
                                window.location.replace(response.url);
                            }, 2000)
                            showNotification(response.message, type);
                            
                            return false;
                        } else {
                            $('.btn_follow_block').html(response.button);
                        }
                    }
                }

                showNotification(response.message, type);
            }
        });
        
        return false;
    });

    /* Unfolow button click */
    body.on('click', '.hs_following_btn', function () {

        var self = $(this);
        $('.loading_pop_up').show();
        $.ajax({
            type: 'POST',
            url: $(this).data('url'),
            success: function (response) {
                var followModal = self.hasClass('hs_company_following')? $('#subscribe-modal') :$('#un_follow_modal');
                followModal.find('.modal-body').html(response.content);
                $('.loading_pop_up').hide();
                followModal.modal('show');
            }
        });
        return false;

    });

    /* Unfollow form submit */
    body.on('submit', '#unfollow-form', function (e) {
        e.preventDefault();
        $('.loading_pop_up').show();
        var self = $(this);
        $.ajax({
            type: 'POST',
            url: self.attr('action'),
            data: self.serialize(),
            success: function (response) {
                var type = 'error';
                if(response.success) {
                    type = 'success';
                    if(response.job_list) {
                        $('.hs_job_list_item').each(function () {
                            var dataId = $(this).attr('data-id');
                            if(response.follow_jobs[dataId]) {
                                $(this).find('.btn_follow_block').html(response.follow_jobs[dataId]);
                            }
                        })
                    }
                    else {
                        if(response.type == 'company') {
                            $("div[data-id="+response.company_id+"]").find(".btn_follow_block").html(response.button);
                        }
                        else {
                            $('.btn_follow_block').html(response.button)
                        }

                    }
                }
                $('#un_follow_modal').modal('hide');
                showNotification(response.message, type);
                $('.loading_pop_up').hide();
            }
        });

    });

    /* unfollow modal checkbox event */
    body.on('change', '.select_alerts', function(){
        if($("#unfollow-form").find('.select_alerts:checked').length){
            $('#unfollow-form').find('.btn_confirm_unfollow_for_job').attr('disabled', false);
        }
        else {
            $('#unfollow-form').find('.btn_confirm_unfollow_for_job').attr('disabled', true);
        }
    });

    /*Save guest user communication*/
    body.on('submit', '#guest_communication_form', function (e) {
        e.preventDefault();
        $('.loading_pop_up').show();
        var self = $(this);
        $.ajax({
            type: 'POST',
            url: self.attr('action'),
            data: self.serialize(),
            success: function (response) {
                var type = 'error';
                if(response.success) {
                    type = 'success';
                    if($('#guest_email_block').length) {
                        $('#guest_email_block').remove();
                    }
                }

                $('.loading_pop_up').hide();
                showNotification(response.message, type);
            }
        });
    });

    /* Toggle guest user setting email */
    body.on('change', '#guest_email_check', function () {
        if($(this).is(':checked')) {
            $('#guest_email_block').removeClass('no_display')
        }
        else {
            $('#guest_email_block').addClass('no_display')
        }
    });

    body.on('submit', '#subscription_form_home', function (e) {
        e.preventDefault();
        openFollowModal({'from': 'jobs_list', 'email': $(this).find('#jobalertsform-email').val()}, null);
    });


    function openFollowModal(data, parent) {

        $('.loading_pop_up').show();

        $.ajax({
            url: $('#open_subscription_modal').val(),
            type: 'POST',
            data: data,
            success: function( response ){

                var followModal = $('#follow_modal');
                followModal.find('.follow_modal_body').html(response);


                if(parent) {
                    orderFollowBlocks(parent);
                    initFollowTypeSelect2();
                }


                frequencyObj = JSON.parse($('#frequency_data').text());
                followModal.find('#frequency_slider').ionRangeSlider({
                    grid: true,
                    from: followModal.find('#frequency_slider').val(),
                    values: frequencyObj,
                    onFinish: function (data) {
                        data.input.next("input").attr("value", frequencyObj.indexOf(data.from_value));
                    }
                });

                setTimeout(function () {
                    $('.loading_pop_up').hide();
                    followModal.modal('show');
                }, 1000);



            },
        });

    }

    function orderFollowBlocks(parent) {
        var companyBlock = $('#company_follow_block');
        var skillBlock = $('#skill_follow_block');
        var categoryBlock = $('#category_follow_block');

        if(parseInt(parent) === 1) {
            companyBlock.find('select').attr('multiple', false);
            $('#company_follow_block').remove();
            $('.filtered_order').append(companyBlock);
            companyBlock.find('.parent_headline').show();
            skillBlock.addClass('pl40');
            categoryBlock.addClass('pl40');
        }
        else if(parseInt(parent) === 3) {
            skillBlock.find('select').attr('multiple', false);
            $('#skill_follow_block').remove();
            $('.filtered_order').append(skillBlock);
            skillBlock.find('.parent_headline').show();
            companyBlock.addClass('pl40');
            categoryBlock.addClass('pl40');

        }
        else {
            categoryBlock.find('select').attr('multiple', false);
            categoryBlock.find('.parent_headline').show();
            companyBlock.addClass('pl40');
            skillBlock.addClass('pl40');
        }

    }

    function initFollowTypeSelect2() {

        $('#follow_modal').find('.follow_type_select').each(function () {
            var placeholder = $(this).data('placeholder');
            var errorMsg = $(this).data('error');
            var attr = {placeholder: placeholder, width: 'resolve'};

            if(!$(this).attr('multiple')) {
                attr.allowClear = true;
            }
            else {
                attr.maximumSelectionLength = 5;
                attr.language = {
                    maximumSelected: function (e) {
                        return errorMsg;
                    }
                };

            }

            $(this).select2(attr)
        });

    }

    function initIonSlider(show_one_item) {

        var languageValue = [];
        languageValue[0] = $("#beginner").val();
        languageValue[1] = $("#advanced").val();
        languageValue[2] = $("#full_proficiency").val();
        languageValue[3] = $("#native").val();

        var selected_langs_ids = [];
        var selected_lang = '';
        var select_inputs = $('#languages .dynamicform_wrapper_langs .select-input1');
        var dynamicform_wrapper_langs = $('#languages .dynamicform_wrapper_langs');
        select_inputs.each(function(key, value){
            selected_lang = $(value).val();
            selected_langs_ids.push(selected_lang);
            select_inputs.not(value).find('option[value="' + selected_lang + '"]').attr('disabled', true);
        });
        select_inputs.select2({ width: '100%' });
        dynamicform_wrapper_langs.find('.select2-container--default').toggleClass('select2-container--default select2-container--krajee');

        dynamicform_wrapper_langs.on('select2:selecting', '.select-input1', function(){
            var lang_id = $(this).val();
            disableOrEnableOption(false, lang_id, this, selected_langs_ids, dynamicform_wrapper_langs, 'select-input1');
        });

        dynamicform_wrapper_langs.on('select2:select', '.select-input1', function(){
            var lang_id = $(this).val();
            disableOrEnableOption(true, lang_id, this, selected_langs_ids, dynamicform_wrapper_langs, 'select-input1');
        });


        $('.language_slider').each(function () {
            $(this).ionRangeSlider({
                grid: true,
                from: $(this).val() - 1,
                values: languageValue,
                onFinish: function (data) {
                    data.input.next("input").attr("value", languageValue.indexOf(data.from_value) + 1);
                }
            });
        });


        $(".dynamicform_wrapper_langs").on("afterInsert", function(e, item) {
            for(var i = 0; i < selected_langs_ids.length; i++) {
                $(item).find('.select-input1').find('option[value="' + selected_langs_ids[i] + '"]').attr('disabled', true);
            }
            $(item).find('.select-input1').select2("val", "");
            $(item).find('.select2-container--default').toggleClass('select2-container--default select2-container--krajee');
            $(item).find('.remove-language').attr('data-id', null);
            $(item).find(".language_slider").next("input").attr("value", 1);

            $(item).find(".language_slider").ionRangeSlider({
                grid: true,
                values: languageValue,
                onFinish: function (data) {
                    data.input.next("input").attr("value", languageValue.indexOf(data.from_value) + 1);
                }
            });

            $('[data-toggle="tooltip"]').tooltip();

            if($(".language").length != 1){
                _isLastLang = false;
            }

        });

        $(".dynamicform_wrapper_langs").on("beforeDelete", function(e, item) {
            var lang_id = $(item).find('.select-input1').val();
            disableOrEnableOption(false, lang_id, $(item).find('.select-input1'), selected_langs_ids, dynamicform_wrapper_langs, 'select-input1');
        });

        // var _isLastLang = $(".language").length == 1 ? true : false;
        //
        // $('.remove-language').on('click', function () {
        //     if(_isLastLang == true){
        //         $(".language").remove();
        //         $("#add-lamg").removeClass('hide');
        //     }
        //
        //     if($(".language").not('.removed').length == 1){
        //         _isLastLang = true;
        //     }
        // });

        if(show_one_item) {
            dynamicform_wrapper_langs.find("button.add-item").click();
        }
    }

    function initSkillIonSlider() {

        var knowledge_level = $(".knowledge_level");
        var levelsObj = JSON.parse($('#knowledge_levels').val());
        var levelArray = [];
        $.each(levelsObj, function (key, value) {
            levelArray.push(value);
        });

        var selected_skills_ids = [];
        var selected_skill = '';
        var select_inputs = $('#hard-skills .skill_dynamicform_wrapper .select-input');
        var skill_dynamicform_wrapper = $('#hard-skills .skill_dynamicform_wrapper');
        select_inputs.each(function(key, value){
            selected_skill = $(value).val();
            selected_skills_ids.push(selected_skill);
            select_inputs.not(value).find('option[value="' + selected_skill + '"]').attr('disabled', true);
        });
        select_inputs.select2({ width: '100%' });
        skill_dynamicform_wrapper.find('.select2-container--default').toggleClass('select2-container--default select2-container--krajee');

        skill_dynamicform_wrapper.on('select2:selecting', '.select-input', function(){
            var skill_id = $(this).val();
            disableOrEnableOption(false, skill_id, this, selected_skills_ids, skill_dynamicform_wrapper, 'select-input');
        });

        skill_dynamicform_wrapper.on('select2:select', '.select-input', function(){
            var skill_id = $(this).val();
            disableOrEnableOption(true, skill_id, this, selected_skills_ids, skill_dynamicform_wrapper, 'select-input');
        });

        knowledge_level.each(function (i) {
            $(this).ionRangeSlider({
                grid: true,
                from: $(this).val()-1,
                values: levelArray,
                onFinish: function (data) {
                    data.input.next("input").attr("value", levelArray.indexOf(data.from_value) + 1);
                }
            });
        });

        $(".skill_dynamicform_wrapper").on("afterInsert", function(e, item) {

            var selectInput = $(item).find('.select-input');
//            for(var i = 0; i < selected_skills_ids.length; i++) {
////                console.log(selectInput.find('option'));
////                console.log(selectInput.find('option[value="' + selected_skills_ids[i] + '"]'));
//                selectInput.find('option[value="' + selected_skills_ids[i] + '"]').attr('disabled', true);
//            }
            selectInput.select2("val", "");
            $(item).find('.select2-container--default').toggleClass('select2-container--default select2-container--krajee');
            $(item).find('.remove-skill').attr('data-id', null);

            $(item).find(".knowledge_level").ionRangeSlider({
                grid: true,
                from: $(this).val()-1,
                values: levelArray,
                onFinish: function (data) {
                    data.input.next("input").attr("value", levelArray.indexOf(data.from_value) + 1);
                }
            });

            if($(".skill").not(".removed").length == 10){
                $(".skill_dynamicform_wrapper").trigger('limitReached');
            }

            unrateSkill();
            $('[data-toggle="tooltip"]').tooltip();

            if($(".skill").not(".removed").length != 1){
                _isLastSkill = false;
            }
            setTimeout(function(){
                var $elements = $('#hard-skills .skill_dynamicform_wrapper .visible.row select')
                $elements.each(function(i, val){

                    if (i === ($elements.length - 1)){

                        var $self = $(this)

                        $self.on('change', function(){
                            $('#add_hard_skill').attr('disabled', !$self.val());
                        });
                    }

                    if (!$(this).val()) {
                        $('#add_hard_skill').attr('disabled', true);
                    }
                });

            }, 300);
        });



        $(".skill_dynamicform_wrapper").on("limitReached", function(e) {

            $(".skill").last().append("<p class='col-xs-12 skills_limit_text_container mrgt20'>" + $("#skills_limit_text").val() +"</p>");
            $('#add_hard_skill').attr('disabled', true);
            $('#request_new_skill_text').addClass('hidden');
        });

        $(".skill_dynamicform_wrapper").on("afterDelete", function(e) {
            $('.skills_limit_text_container').remove();
            $('#request_new_skill_text').removeClass('hidden');
        });

        $(".skill_dynamicform_wrapper").on("beforeDelete", function(e, item) {
            var skill_id = $(item).find('.select-input').val();

            if (!skill_id){
                $('#add_hard_skill').attr('disabled', false);
            }

//            disableOrEnableOption(false, skill_id, $(item).find('.select-input'), selected_skills_ids, skill_dynamicform_wrapper, 'select-input');
        });

        if($(".skill").not(".removed").length == 10){
            $('#request_new_skill_text').addClass('hidden');
        }

        var _isLastSkill = $(".skill").not(".removed").length == 1 ? true : false;

        $('.remove-skill, .remove-new-hard-skill').on('click', function () {

            if(_isLastSkill == true){
                $(".skill").remove();
                $("#add-skill").removeClass('hide');
            }

            if($(".skill").not('.removed').length == 1){
                _isLastSkill = true;
            }
        });
    }

    function disableOrEnableOption(is_disable, id, element, selected_ids, dynamicform_wrapper, select_input_class){
        var skill_index = selected_ids.indexOf(id);
        if((!is_disable && skill_index !== -1) || (is_disable && skill_index === -1)){
            if(!is_disable) {
                selected_ids.splice(skill_index, 1);
            }
            else {
                selected_ids.push(id);
            }
            dynamicform_wrapper.find('.' + select_input_class).not(element).find('option[value="' + id + '"]').attr('disabled', is_disable);
            dynamicform_wrapper.find('.' + select_input_class).not(element).select2({ width: '100%' });
            dynamicform_wrapper.find('.select2-container--default').toggleClass('select2-container--default select2-container--krajee');
        }
    }

    function initTitleAutoComplete() {

        var field = $("#employmentform-company_title");
        field.autocomplete({
            source: function(request, response){
                var currentRequest = null;
                currentRequest = $.ajax({
                    type: 'GET',
                    url: $('#url_companies_list').val(),
                    beforeSend : function()    {
                        if(currentRequest != null) {
                            currentRequest.abort();
                        }
                    },
                    data: {
                        term: request.term
                    },
                    success: function(data) {
                        response(data)
                    }
                });
            }
        });
    }

    function unrateSkill() {
        $('.not_rated_skill').each(function(i) {
            $(this).on('change', function() {
                if($(this).is(':checked') == true)
                {
                    $(this).val(1);
                    $(this).parent().parent('div').next().addClass('hide');
                    $(this).parent().parent('div').next().hide();
                    $(this).parent().parent('div').next().next("p").hide();
                }
                else
                {
                    $(this).val(0);
                    $(this).parent().parent('div').next().removeClass('hide');
                    $(this).parent().parent('div').next().show();
                    $(this).parent().parent('div').next().next("p").show();
                }
            });
        });
    }

    unrateSkill();

    $(body).on('click', function(e){
        if(!$(e.target).is('button.navbar-toggle') && !$(e.target).is('div.navbar-collapse.collapse') && !$(e.target).parents('div.navbar-collapse.collapse').length){
            $('div.navbar-collapse.collapse').collapse('hide');
        }
    });

    $('.close_cookie_block').on('click', function(){
        $('.cookie_blog').addClass('hidden');
        setCookie('cookie_block', true, 365, $(this).data('domain'));
        var y = $(window).scrollTop();
        if($(document).height() - (y + $(window).height()) < 275) {
            $('#btn_scroll_top').css('bottom', 353 - ($(document).height() - (y + $(window).height())) + 'px');
        }
        else {
            $('#btn_scroll_top').css('bottom', '80px');
        }
        $('.subscribe.jobs-page-subscribe').css('bottom', '0');
    });

    $('#apply_now_in_additional_section').on('click', function(e){
        e.preventDefault();
        $('.apply_btn_button').trigger('click');
    });



    $('.tabs-box button').on('click', function(e) {
        if ($(window).width() >= 1000) {
            job_training_packages_owl_carousel.trigger('to.owl.carousel', [$(this).index(), 300]);
        }
    });
    function selectedActiveTab(event) {
        var activeElements = $(event.target).find(".owl-item.active");
        var parentElements = activeElements.find('.owl-parent');
        var activeTabId = '#' + parentElements.data('activeTab');
        $('.tabs-box button').removeClass('active');
        $(activeTabId).addClass('active');
    }

    body.on('click', '.mail-check button.alert-close', function(){
        $('body').removeClass('modal-open');
    });

    body.on('click', '.btn-request-to-change-package', function (e) {
        e.preventDefault();
        if($(this).hasClass('post_job_btn_from_nav_bar')){
            $('#jobs_expired_draft_expired').modal('show');
        }
        else {
            if($(this).hasClass('from_job_post_page')){
                $('#jobs_expired').find('a.go_to_billing').addClass('hidden');
                $('#jobs_expired').find('a.save_as_draft_and_go_to_billing').removeClass('hidden');
            }
            $('#jobs_expired').modal('show');
        }

        // var status = $(this).attr('data-type');
        // var url = $(this).attr('data-arg');
        // var href;
        // if(status == 'post-job') {
        //     href = url+'?type=post';
        // }
        // if(status == 'deactivate-job') {
        //
        //     href = url+'?type=deactivate';
        //
        // }
        //
        // $.get(encodeURI(href), function (data) {
        //     $('#request-to-change-package').modal('show')
        //         .find('#modalContent1')
        //         .html(data);
        //     $('#request-to-change-package').find('#contactform-subject').select2({minimumResultsForSearch: -1,theme: 'default hs_home_search_select'})
        // });
    });
    if ($('#hs_company_side_menu').hasClass('close_nave')) {
        $('#log-in-header').find('li').each(function (key, value) {
            $(value).attr('title', $(value).data('title'));
        });
    } else {
        $('#log-in-header').find('li').attr('title', '')
    }
    body.on('click', '#btn_side_menu_toggle', function () {
        if ($('#hs_company_side_menu').hasClass('close_nave')) {
            $('#log-in-header').find('li').each(function (key, value) {
                $(value).attr('title', $(value).data('title'));
            });
        } else {
            $('#log-in-header').find('li').attr('title', '')
        }
    });

    $(document).on("click", ".job_save", function (e) {
        var self = $(this);
        e.preventDefault();
        if (!$(this).data('job_id')) {
            if($('#site_type').val() == 'staff') {
                openSignInModal()
            }
            else {
                $('#login_modal').modal('show');
            }

        } else {
            if ($('#save_job').hasClass('hs_unsave') && !$('.saved_job_bookmark').hasClass('hidden')) {
                var url = $(this).data('href');
            } else {
                var url = $(this).data('action');
            }
            $.ajax({
                url: url,
                type: 'get',
                success: function (response) {
                    var type = 'success';
                    if (response.success) {
                        if (url === self.data('action')) {
                            self.find('.save_job_bookmark').addClass('hidden');
                            self.find('.saving_text').addClass('hidden');
                            self.find('.unsaving_text').removeClass('hidden');
                            self.find('.saved_job_bookmark').removeClass('hidden');
                        } else {
                            self.find('.save_job_bookmark').removeClass('hidden');
                            self.find('.saving_text').removeClass('hidden');
                            self.find('.unsaving_text').addClass('hidden');
                            self.find('.saved_job_bookmark').addClass('hidden');
                        }
                        if(self.hasClass('expired_job')){
                            self.remove();
                        }
                    }
                    showNotification(response.message, type);
                }
            });
        }

    });

    $(document).on("click", ".saved_list_unsaved", function (e) {
        e.stopPropagation();
        var self = $(this);
        block = $(this).closest('.job-list-item');
        var url = self.data('action');
        $('#confirm_modal_for_saved_jobs').modal('show');
        $('#confirm_modal_for_saved_jobs .btn_confirm_action_saved_jobs').data('url', url);
    });
    $(document).on('click', '.btn_confirm_action_saved_jobs', function () {
        var url = $(this).data('url');
        var self = $(this);
        $.ajax({
            url: url,
            type: 'get',
            success: function (response) {
                var type = 'error';
                if (response.success) {
                    block.remove();
                    type = 'success';
                    if(!$('#saved_jobs_container').find('.job-list-item').length){
                        $('#saved_jobs_empty_block').removeClass('hidden');
                    }
                }
                showNotification(response.message, type);
            }

        });
        $(this).closest('.modal').modal('hide');
    });

    $(document).on("submit", "#phone_number_phone_form", function (e) {
        var $self = $(this);
        var url = $self.attr('action');
        var formData = new FormData($(this)[0]);
        $.ajax({
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            url: url,
            success: function (response) {
                if (response.success) {
                    $('.mail-check-content').removeClass('hide');
                    $('.fillPhoneNumberModal').addClass('hide');
                }
                else {
                    showNotification(response.message, 'error')
                }
            }
        });
        return false;
    });


    $('#modal').on('hidden.bs.modal', function () {
        if ($(this).find('.fillPhoneNumberModal').length) {
            var url = $('#phone_number_phone_form').data('href');
            window.location.replace(url);
        }
    });

    $(body).on('submit', '#applyNowForm', function (e) {
        var $self = $(this);
        var url = $self.attr('action');
        var formData = new FormData($(this)[0]);
        var button = $self.find('.applyNowModalBtn');
        button.attr('disabled', true).append('<i class="fa fa-spinner fa-spin ml10" aria-hidden="true"></i>');
        $.ajax({
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            url: url,
            success: function (response) {
                $('#hs_default_modal').modal('hide');
                if (response.success) {
                    if (typeof gtag == 'function') {
                        gtag('event', 'apply_cv', {'how_to_apply': 'with_staffcv'});
                    }

                    $('#redirect-url').val(response.url);
                    $('#secretsalaryform-applicant_id').val(response.applicant_id);
                    $('#secret_salary_modal_applicant').modal('show');
                } else {
                    showNotification(response.message, 'error');
                }
            }
        });
        return false;
    });

    $('.navigate_to_other_tab').on('click', function(){
        if ($(this).hasClass("next-tab"))
        {
            var element = $('.pricing_tab.active').next('.pricing_tab');
        }
        else
        {
            var element = $('.pricing_tab.active').prev('.pricing_tab');
        }

        element.trigger('click');
    });

    $('#login_modal, #comingSoon, #reset_password').on('show.bs.modal', function(){
        $(this).find('img.lazy').each(function(key, value){
            $(value).attr('src', $(value).attr('data-original'));
        });
    });
    body.on('click', '.has_search_option_modal', function (e) {
        $('#has_search_option_modal').modal('show');
    });

    body.on('click', '.show_followers_option_modal', function (e) {
        $('#show_followers_option_modal').modal('show');
    });

    /* Replay invitation event */
    $('#hs_default_modal').on('click', '.btn_inv', function () {
        var parentElement = $(this).parent('.inv-buttons-block');
        var self = $(this);
        var invitationId = parentElement.data('id');
        $('#hs_default_modal').find('.modal-centered-loader').show();
        $.ajax({
            url: parentElement.data('url'),
            type: 'post',
            data: {
                status: self.data('type'),
                id: invitationId,
                type: parentElement.data('type'),
                applicant_id: parentElement.data('applicant_id'),
                pipeline_user_id: parentElement.data('pipeline_user_id'),
                login_via: $('#hs_default_modal .login_via').val(),
                from_user_profile: $('#hs_default_modal .from_user_profile').val()
            },
            success: function (response) {
                $('#hs_default_modal').find('.modal-centered-loader').hide();
                if(response.success) {
                    $('#hs_default_modal').find('.modal_main_body').html(response.content);
                    $('#hs_default_modal').find('.modal-footer .back_to_apply_buttons').hide();
                    $('#hs_default_modal').find('.modal-body.invitation_wizard').removeClass('cv_bg');
                    var carousel = $('#hs_job_carousel');
                    if(carousel.length) {
                        carousel.find('.owl-item.active .inv-buttons-block').html(response.statusText);
                    }
                    else if($('#invited_jobs_list_block').length) {
                        $('#invited_jobs_list_block').find('.invited_job_list_item[data-id="' + invitationId + '"]').find('#inv_status_block').html(response.statusText);
                    }

                    $('#secretsalaryform-applicant_id').val(response.applicant_id);
                }
                else {
                    if (response.message) {
                        showNotification(response.message, type);
                    }
                }
            }
        });

    });

    body.on('click', '.invitation_status_btn', function () {

        var self = $(this);
        var invitationId = self.data('id');
        $.ajax({
            url: self.data('url'),
            type: 'post',
            data: {
                status: self.data('status'),
                id: invitationId,
                type: self.data('type'),
                applicant_id: self.data('applicant_id'),
                pipeline_user_id: self.data('pipeline_user_id')
            },
            success: function (response) {
                var type = 'error';
                if(response.success) {
                    type = 'success';
                    var carousel = $('#hs_job_carousel');
                    $('#hs_default_modal').modal('hide');
                    if(carousel.length) {
                        carousel.find('.owl-item.active .inv-buttons-block').html(response.statusText);
                    }
                    else if($('#invited_jobs_list_block').length) {
                        $('#invited_jobs_list_block').find('.invited_job_list_item[data-id="' + invitationId + '"]').find('#inv_status_block').html(response.statusText);
                    }
                }
                showNotification(response.message, type);
            }
        });

    });

    /* Reject invitation from profile */
    $(document).on("click", ".list_btn_reject", function (e) {
        e.stopPropagation();
        var self = $(this);
        var defaultModal = $('#hs_default_modal');
        defaultModal.modal('show');
        $.ajax({
            url: self.data('action'),
            success: function (response) {
                if(response.success) {
                    defaultModal.find('.modal-body').html(response.content)
                }
            }
        });
    });

    //Default ajax button click
    body.on('click', '.btn_default', function () {
        $('.loading_pop_up').show();
        var data = {};
        var attr = $(this).attr('data-request');
        if(typeof attr !== typeof undefined && attr !== false) {
            data = attr;
        }
        const invBtn = $(this).hasClass('btn_inv_apply');
        $.ajax({
            url: $(this).data('url'),
            type: 'post',
            data: {data:data},
            success: function (response) {
                if(response.success) {
                    $('.loading_pop_up').hide();
                    if(invBtn) {
                        $('#hs_default_modal').attr({'data-backdrop': 'static', 'data-keyboard': 'false'});
                    }
                    $('#hs_default_modal').modal('show').find('.modal-content').html(response.content);
                }
            }
        });

    });

    body.on('submit', '#delete_invitation_form', function (e) {
        e.preventDefault();
        var $this = $(this);
        $.ajax({
            url: $this.attr('action'),
            type: 'post',
            success: function (response) {
                $('#hs_default_modal').modal('hide');
                var type = 'error';
                if(response.success) {
                    $('#invited_jobs_list_block').find('div[data-id='+response.id+']').remove();
                    type = 'success';
                }
                showNotification(response.message, type);
            }
        });
    });

    $('.sub_navbar a.dropdown-toggle').on('click', function(){
        $(this).parents('ul.nav.navbar-nav').find('.sub_navbar.open_submenu').not($(this).parents('.sub_navbar')).removeClass('open_submenu open')
        $(this).parents('.sub_navbar').toggleClass('open_submenu');
    });

    if ($('#logged_menu').find('ul').length > 0){
        $('#logged_menu').hcOffcanvasNav({
            maxWidth: 980,
            customToggle: $('#toggle_user_menu'),
            pushContent: '.container',
            navClass: 'hs_mobile_nav',
            labelClose: '',
            levelOpen: 'none',
            closeOnClick: false,
        }).on('close', function(event, settings) {
            $('#toggle_user_menu').show();
            $('#toggle_user_menu_close').hide();
        }).on('open', function(){
            $('#toggle_user_menu').hide();
            $('#toggle_user_menu_close').show();
        });
    }
    $('#not_logged_menu').hcOffcanvasNav({
        maxWidth: 980,
        position: 'right',
        navClass: 'hs_mobile_nav hs_mobile_nav_right',
        pushContent: '.container',
        labelClose: '',
        levelOpen: 'none',
        closeOnClick: false,
        levelSpacing:25
    });

    body.on('click', '.invitation_apply_online', e => {
        $('#hs_default_modal').attr({'data-backdrop': 'static', 'data-keyboard': 'false'}).find('.modal-centered-loader').show();
        $.ajax({
            url: $(e.currentTarget).attr('data-url'),
            type: 'get',
            success: response => {
                $('#hs_default_modal').find('.modal_main_body').html(response);
                $('#hs_default_modal').find('.modal-centered-loader').hide();
                $('#hs_default_modal').find('.back_to_apply_buttons').show();
            }
        });
    });

    body.on('submit', '#apply-login-form', e => {
        e.preventDefault();
        $('#hs_default_modal').find('.modal_main_body');
        $('#hs_default_modal').find('.modal-centered-loader').show();
        const url = $(e.currentTarget).attr('action');
        let formData = new FormData($(e.currentTarget)[0]);
        formData.append('applicant_id', $('#invited_applicant_id').val());
        formData.append('pipeline_user_id', $('#invited_pipeline_user_id').val());
        formData.append('invitation_id', $('#hs_job_carousel').find('.owl-item.active .invitation_id').val());
        $.ajax({
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            url: url,
            success: response => {
                $('#hs_default_modal').find('.modal-content').html(response);
            }
        });
    });

    body.on('click', '.invitation_apply_guest, .load_question_form', e => {

        const currentTarget = $(e.currentTarget);
        if(currentTarget.hasClass('load_question_form')){
            $('.loading_pop_up').show();
        }
        else {
            $('#hs_default_modal').find('.modal-centered-loader').show();
        }
        var activeItem = $('#hs_job_carousel').find('.owl-item.active');
        if(!activeItem.length){
            activeItem = currentTarget.parents('.invited_job_list_item');
        }
        var data = {
            company_id: activeItem.find('.company_id').val(),
            company_title: activeItem.find('.company_title').val(),
            job_id: activeItem.find('.job_id').val(),
            job_title: activeItem.find('.job_title').val(),
        };
        if(currentTarget.hasClass('load_question_form')) {
            data['login_via'] = 1
        }

        $.ajax({
            url: currentTarget.data('url'),
            type: 'GET',
            data: data,
            success: response => {
                if(currentTarget.hasClass('load_question_form')) {
                    $('#hs_default_modal').find('.modal-content').html(response);
                }
                else {
                    $('#hs_default_modal').find('.modal_main_body').html(response);
                }
                setTimeout(() => {
                    $('#hs_default_modal').find('.modal-centered-loader').hide();
                    if($('#questions-tabs1').length) {
                        var textElement = $('#text_elements');
                        var form = $('#apply_form');
                        form.validate({
                            rules: formRules,
                            errorPlacement: (error, element) => {
                                if($(element).hasClass('question_check_radio') || $(element).hasClass('select2-hidden-accessible')) {
                                    error.appendTo( $(element).parents('.form-group'));
                                }
                                else {
                                    $(element).after(error);
                                }
                            }
                        });
                        $.when($('#questions-tabs1')
                            .steps({
                                headerTag: 'h3',
                                bodyTag: 'section',
                                labels: {
                                    finish: textElement.attr('data-apply'),
                                    next: textElement.attr('data-next'),
                                    previous: textElement.attr('data-back')
                                },
                                onFinished: (event, currentIndex) => {
                                    form.trigger('submit');
                                },
                                onStepChanging: (event, currentIndex, newIndex) => {
                                    if (currentIndex > newIndex){
                                        return true;
                                    }

                                    var phoneInputValid = true;
                                    $('section.body.current').find('.qw_phone_input').each(() => {
                                        if($.trim(currentTarget.val()) && !currentTarget.intlTelInput("isValidNumber")) {
                                            phoneInputValid = false;
                                        }
                                    });

                                    return form.valid() && phoneInputValid;
                                },
                                transitionEffect: 'fade',
                                stepsOrientation: 'vertical'
                            })
                        ).done(() => {
                            $('#questions-tabs1').find('input#applyasguestform-email').prop('readonly', true);
                            if(currentTarget.hasClass('load_question_form')) {
                                $('.loading_pop_up').hide();
                                $('#hs_default_modal').attr({'data-backdrop': 'static', 'data-keyboard': 'false'}).modal('show');
                            }
                        });
                    }
                    if(currentTarget.hasClass('load_question_form')) {
                        $('.loading_pop_up').hide();
                        $('#hs_default_modal').attr({'data-backdrop': 'static', 'data-keyboard': 'false'}).modal('show');
                    }
                    else {
                        $('#hs_default_modal').find('.back_to_apply_buttons').show();
                    }

                }, 500);
            }
        });
    });

    body.on('submit', '#invitation-apply-as-guest, #hs_default_modal .job_questions form#apply_form', e => {
        e.preventDefault();
        const url = $(e.currentTarget).attr('action');
        let formData = new FormData($(e.currentTarget)[0]);
        formData.append('from_invitation', '1');
        if($('#hs_default_modal .login_via').length){
            formData.append('login_via', $('#hs_default_modal .login_via').val());
        }
        if($('#hs_default_modal .from_user_profile').length){
            formData.append('from_user_profile', $('#hs_default_modal .from_user_profile').val());
        }
        if($('#hs_default_modal .invitation_id').length){
            formData.append('invitation_id', $('#hs_default_modal .invitation_id').val());
        }
        $('#hs_default_modal').find('.modal-centered-loader').show();
        $.ajax({
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            url: url,
            success: response => {
                $('#hs_default_modal').find('.modal-centered-loader').hide();
                if (response.success) {
                    let carousel = $('#hs_job_carousel');
                    $('#hs_default_modal').find('.modal_main_body').html(response.content);
                    $('#hs_default_modal').find('.modal-footer .back_to_apply_buttons').hide();

                    if (carousel.length) {
                        carousel.find('.owl-item.active .inv-buttons-block').html(response.statusText);
                    } else if ($('#invited_jobs_list_block').length) {
                        $('#invited_jobs_list_block').find('.invited_job_list_item[data-id="' + response.invitation_id + '"]').find('#inv_status_block').html(response.statusText);
                    }

                    $('#secretsalaryform-applicant_id').val(response.applicant_id);
                }
                else {
                    if (response.message) {
                        showNotification(response.message, 'error');
                    }
                }
            }
        });
    });

    body.on('click', '.back_to_apply_buttons', e => {
        $('#hs_default_modal').find('.modal-centered-loader').show();
        $.ajax({
            url: $(e.currentTarget).attr('data-url'),
            type: 'post',
            data: {data: $(e.currentTarget).attr('data-request')},
            success: response => {
                if(response.success){
                    $('#hs_default_modal').find('.modal-content').html(response.content);
                }
            }
        });
    });

    $('.toggle_return_policy_block').on('click', e => {
        $('.return_policy_block').slideToggle();
    });

    $('#select_sort').select2({
        minimumResultsForSearch: -1
    });

    $('#secret_salary_modal_applicant').on('hide.bs.modal', function (e) {
        redirectSecretSalary();
    });

    $('#secret_salary_form').on('beforeSubmit', function (e) {
        $(this).find('.btn-primary').attr('disabled', true);
        const data = $(this).serialize();
        $.ajax({
            url: $(this).attr('action'),
            type: 'POST',
            data: data,
            success: function (response) {
                if (response.success) {
                    if (!redirectSecretSalary()) {
                        $('#secret_salary_modal_applicant').modal('hide');
                    }
                } else {
                    showNotification(response.message, 'error');
                }
            },
            error: function (jqXHR, errMsg) {
                showNotification(errMsg, 'error');
            }
        });
        return false;
    });

    function redirectSecretSalary() {
        const url = $('#redirect-url').val();
        if (url) {
            window.location.href = url;
            return true;
        } else {
            return false;
        }
    }

    body.on('beforeSubmit', '#form-apply-as-guest', function () {
        const formData = new FormData($(this)[0]);
        $.ajax({
            url: $(this).attr('action'),
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            success: function (response) {
                if (typeof gtag == 'function') {
                    gtag('event', 'apply_cv', {'how_to_apply': 'attach_cv'});
                }

                if ($('#secret_salary_modal_applicant').length) {
                    $('#hs_default_modal').modal('hide');
                    $('#redirect-url').val(response.url);
                    $('#secretsalaryform-applicant_id').val(response.applicant_id);
                    $('#secret_salary_modal_applicant').modal('show');
                } else if (response.url) {
                    window.location.href = response.url;
                }
            },
            error: function(jqXHR, errMsg) {
                showNotification(errMsg, 'error');
            }
        });
        return false;
    });
});

$(document).on("submit", "#subscribe, #subscribe_from_companies_list", function (e) {
    e.preventDefault();

    var $this = $(this);

    var companyId = $this.find('#company_id:checked').val();
    var categoryId = $this.find('#categoryId:checked').val();
    var itemId = $this.find('#item_id').val();
    if(!itemId){
        itemId = $this.find('#job_item_id').val();
    }
    if(!companyId){
        companyId = $this.find('#job_company_id:checked').val();
    }
    $.ajax({
        url: $this.attr('action'),
        type: 'post',
        data: $this.serialize(),
        success: function (result) {
            $this.closest('.modal').modal('hide');

            if(result.success) {
                if(result.login) {
                    var template = '';
                    $('.web_item_card').find('.btn_follow_block').each(function(key, value){
                        if($(value).data('type') === 'job'){
                            template = _.template($('#tpl_following_button_for_jobs').html());
                        }
                        else{
                            template = _.template($('#tpl_following_button').html());
                        }
                        var btn_follow = $(value).find('.btn-follow');
                        var btn_companyid = btn_follow.data('companyid');
                        var btn_categoryid = btn_follow.data('categoryid');
                        var btn_companyTitle = btn_follow.data('companytitle');
                        var btn_categoryTitle = btn_follow.data('categorytitle');
                        if(btn_companyid && btn_companyid == companyId || btn_categoryid && btn_categoryid == categoryId){
                            $(value).html(template({
                                companyId : btn_companyid,
                                categoryId:btn_categoryid,
                                companyTitle: btn_companyTitle,
                                categoryTitle: btn_categoryTitle
                            }));
                        }
                    });
                    if($('#followers_count').length){
                        $('#followers_count').text(parseInt($('#followers_count').text()) + 1)
                    }
                    else {
                        var followers_count_selector = $('.web_item_card[data-id=' + itemId + ']').find('.followers_count');
                        followers_count_selector.text(parseInt(followers_count_selector.text()) + 1);
                    }
                }
                else {
                    if(itemId) {
                        $('.web_item_card[data-id=' + itemId + ']').find('.btn_follow_block').html('');
                    }
                }
            }


            $('#main-modal').modal('show')
                    .find('.modal-content')
                    .load(encodeURI(result.url));

            $('.jobs-page-subscribe').hide();
        }
    });
});


var openGenderModal = true;

$('#first_login_form').on("submit", function (e) {
    e.preventDefault();
    var $this = $(this);


    var genderChecked = false;
    $('input[name="Users[gender_id]"]').each(function () {
        if($(this).is(':checked')) {
            genderChecked = true;
        }
    });

    if(!$('#users-birthday').val() || !$('#users-birthmonth').val() || !$('#users-birthyear').val()) {
        $('#birthday_error').show();
        return false;
    }
    else {
        $('#birthday_error').hide();
    }

    if(!genderChecked) {
        $('#gender_error').show();
        return false;
    }
    else {
        $('#gender_error').hide();
    }

    $.ajax({
        url: $this.attr('action'),
        type: 'post',
        data: $this.serialize(),
        success: function (result) {
            if(result.success) {
                openGenderModal = false;
                $('#genderAge').modal('hide');
                if($('#gender_name').length) {
                    $('#gender_name').text(result.gender_name);
                    $('#user_gender_icon').attr('class', result.class);
                    $('#user_birth_date').text(result.birth_date);
                }
                location.reload();
            }
            else {
                $('#api_error').text(result.message);
            }

        }
    });


});

$('#genderAge').on('hidden.bs.modal', function () {

    if(openGenderModal) {
        $('#genderAge').modal('show');
        $('#first_login_form').submit();
    }

});

const loadProductSubscrieModal = () => {
    if (window.loadProductSubscrie){
        $('.loading_pop_up').show();
        $.ajax({
            type: 'POST',
            url: window.loadProductSubscrie, //$(this).data('url'),
            success: function (response) {
                var followModal = $('#subscribe-modal');
                followModal.find('.modal-body').html(response.content);
                $('.loading_pop_up').hide();
                followModal.modal('show');
            }
        });
    }
}

function setCookie(cname, cvalue, exdays, domain) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    var cookie_params = cname + "=" + cvalue + ";" + expires + ";path=/";
    if(domain){
        cookie_params += ";domain=" + domain
    }
    document.cookie = cookie_params;
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/* Close modal after cancel button click */
function closeModal(modal) {
    $(modal).modal('hide');
}

function twoDateDiff(start, end) {

    var startDate = new Date(start);
    var endDate = new Date(end);
    var months;
    months = (endDate.getFullYear() - startDate.getFullYear()) * 12;

    months -= startDate.getMonth() + 1;
    months += endDate.getMonth() + 1;


    var diffMonths = months <= 0 ? 0 : months;
    var diffYear = 0;

    if(diffMonths > 12) {
        diffYear = parseInt(diffMonths/12);
        diffMonths = diffMonths - (diffYear * 12);
    }

    var diffObj = {};

    if(diffYear) {
        diffObj.year = diffYear;
    }

    if(diffMonths) {
        diffObj.month = diffMonths;
    }

    return diffObj;

}

function getFoldersFromString(string) {
    return '/' + string.charAt(0) + '/' + string.charAt(1) + '/' + string.charAt(2) + '/' + string.charAt(3) + '/'
}

function getCompanyImage(image) {

    if(image) {
        return 'upload' + getFoldersFromString(image) + image;
    }
    else {
        return '/main/imgs/company-no-image.png'
    }

}

function showNotification(html, type) {

    var bgColor = "#4BC3C1";
    var textColor = "#fff";
    var loadColor = "#3A9795";

    if(type === 'error') {
        bgColor = "#da4744";
        textColor = "#fff";
        loadColor = "#942422";

    }
    else if(type === 'warning') {
        bgColor = "#FFA418";
        textColor = "#fff";
        loadColor = "#D38714";
    }

    $.toast().reset('all');

    $.toast({
        heading: $('#info_heading_text').val(),
        text: html,
        icon: type,
        loader: true,
        bgColor: bgColor,
        textColor: textColor,
        showHideTransition: 'fade',
        allowToastClose: true,
        position: 'top-right',
        loaderBg: loadColor,
        hideAfter: 5000,
    });

}

function updateCompleteness(value, updateAll) {


    if(updateAll) {
        $.each( value, function( key, comVal ) {
            var width = comVal;
            if(parseInt(comVal) === 0) {
                width = $('#empty_completeness_percentage').val();
            }
            $('.cv_lang_tab[data-id='+key+']').find('.profile_completeness_progress .progress-bar').text(comVal + '%').attr('style', 'width:'+width+'%');
        });

    }
    else {
        var progressBar = $('.active .profile_completeness_progress .progress-bar');
        if(progressBar.length) {
            var width = value;
            if(parseInt(value) === 0) {
                width = $('#empty_completeness_percentage').val();
            }
            progressBar.text(value + '%').attr('style', 'width:'+width+'%');
        }
    }


}

soft_skills = [];
function initSelect2(element, maxCount, errorMsg) {

    $(element).select2({
        width: '100%',
        maximumSelectionLength: maxCount,
        allowClear: true,
        language: {
            maximumSelected: function (e) {
                return errorMsg.replace('skills_count', maxCount).replace('requested_skills_count', 10-maxCount);
            }
        }
    });
    if(maxCount === 0) {
        $(element).prop("disabled", true);
    }
    else {
        $(element).prop("disabled", false);
    }
    soft_skills = $(element).val();
}

function isMobile() {
    var check = false;
    (function(a){
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

function sharePopup(url){
    window.open(url , '123456789' , 'height=450,width=830,resizeable=yes');
    return false;
}

function deleteSubscriptions(){
    var subs = [];
    $.each($("input[name='del-sub']:checked"), function(){
        subs.push($(this).val());
    });
    return subs;
}

$("body").on( "click", ".check-all-sub", function( event )  {
    if (this.checked) {
        $('.delete-subs').prop('disabled', false);
        $('.check-inputs input:checkbox').each(function () {
            $(this).prop('checked', true);
        });

    } else {
        $('.delete-subs').prop('disabled', true);
        $('.check-inputs input:checkbox').each(function () {
            $(this).prop('checked', false);
        });
    }
});

$("body").on( "click", ".delete-subs", function(e)  {
    $('#myModal').modal('show');
    var ids = deleteSubscriptions();
    $('.deleteAlertSubmitBtn').on('click', function () {
        $.ajax({
            type: 'POST',
            url: "/users/job-alerts/delete-subscriptions",
            data: {id: ids},
            success: function (response) {
                var type = 'error';
                if (response.success) {
                    type = 'success';
                    $("input[name='del-sub']:checked").closest('.card_item ').remove();
                }

                showNotification(response.message, type);
                $(this).addClass('hide');
            }
        });
        $(this).closest('.modal').modal('hide');
    });
});
 $('.hs_page_content').on('click', '.del-subscription', function (e) {
     e.stopPropagation();
    if (this.checked) {
        $('.delete-subs').prop('disabled', false);
    } else {
        $('.delete-subs').prop('disabled', true);
    }
});
$('.hs_page_content').on('click', '.static_checkbox', function (e) {
    e.stopPropagation();
});
$('.hs_page_content').on('change', '.del-subscription', function (e) {
    e.stopPropagation();
    if ($('.del-subscription:checked').length === $('.del-subscription').length) {
        $('.check-all-sub:checkbox').prop('checked',true);
    }else {
        $('.check-all-sub:checkbox').prop('checked',false);
    }
});



function updateGtagConfig(){
    Fingerprint2.get(function (components) {
        var murmur = Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31);
        ga(function(tracker) {
            var clientId = tracker.get('clientId');
            var referrer = tracker.get('referrer');
            var urlParams = new URLSearchParams(window.location.search);
            var source_id = urlParams.get('source_id');
            var fbclid = urlParams.get('fbclid');
            var gclid = urlParams.get('gclid');
            $.ajax({
                type: 'POST',
                url:ajaxUrl,
                data:{
                    clientId:clientId,
                    referrer:referrer,
                    murmur:murmur,
                    source_id: source_id,
                    fbclid:fbclid,
                    gclid:gclid
                }
            });
        });
    });
}

function onTelegramAuth(user, modal, guest) {

    var data = {
        id: user.id,
        name: user.first_name + ' ' + user.last_name,
        social: $('#hs_social_type').val(),
    };

    if(user.username) {
        data.username = user.username;
    }

    if(guest) {
        data.guest = guest;
    }

    $.ajax({
        type: 'POST',
        url: $('#hs_save_social_url').val(),
        data: data,
        success: function (response) {
            socialLoginModal = false;

            if(!modal) {
                $('#communication_settings').find('#hs_com_telegram').html('<input class="pref_communication" name="communication[]" value="'+response.id+'" type="checkbox" checked><span class="hs_checkbox"></span><span class="hs_comm_name" >Telegram</span>');
            }
            else if(modal == 'update') {
                var telegramLbl = $('.hs_telegram_com');
                telegramLbl.closest('div').find('iframe').remove();
                telegramLbl.removeClass('hidden');
                telegramLbl.find('input[type="checkbox"]').prop('checked', true);
                telegramLbl.find('.icheckbox_minimal-green').addClass('checked');
            }
            else if(modal == 'guest_follow') {
                $('#hs_alert_social_data').val(1);
                $('#hs_social_button_block').html('<span>'+ response.text + '</span>');
                $('#hs_telegram_exist').val(1);
            }
            else if(modal == 'guest_settings') {
                $('#hs_guest_settings_telegram').html('<label id="hs_com_telegram" class="hs_check_radio_lbl hs_communication_lbl">\n' +
                    '                                    <input type="checkbox" class="pref_communication" checked="" name="communication['+$('#hs_telegram_id').val()+']" value="'+response.id+'">\n' +
                    '                                    <span class="hs_checkbox"></span>\n' +
                    '                                    <span class="hs_comm_name">Telegram</span>\n' +
                    '                                </label>')
            }
            else {
                $('#social_login_modal').modal('hide');
            }

            var type = 'error';
            if(response.success) {
                type = 'success';
            }

            showNotification(response.message, type);
        }
    });

}

function guestRegisterModal(data) {
    if($('#site_type').val() == 'staff') {
        openRegisterModal();
    }
    else {
        $('#reg_modal').modal('show');
    }

    if(data.email) {
        $('#signupform-email').val(data.email);
    }

    if(data.first_name) {
        $('#signupform-name').val(data.first_name);
    }

    if(data.last_name) {
        $('#signupform-lastname').val(data.last_name);
    }
}

function loadHotJobs(url, type) {
    $.ajax({
        url: url,
        type: 'POST',
        data: {type:type},
        success: function( response ){
            $('#hot_jobs_block').html(response);
            $('#hot_jobs').owlCarousel({
                loop: true,
                margin: 10,
                lazyLoad : true,
                autoplay: true,
                autoplayTimeout: 3000,
                autoplayHoverPause: true,
                navText: [
                    '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                    '<i class="fa fa-angle-right" aria-hidden="true"></i>'
                ],
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1200: {
                        items: 3,
                        nav:true
                    }
                }
            });
        },
    });
}

function loadHotTrainings(url) {
    $.ajax({
        url: url,
        type: 'POST',
        success: function( response ){
            $('#hot_trainings_block').html(response);
            $('#hot_trainings').owlCarousel({
                loop: true,
                margin: 10,
                lazyLoad : true,
                // autoplay: true,
                // autoplayTimeout: 3000,
                autoplayHoverPause: true,
                navText: [
                    '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                    '<i class="fa fa-angle-right" aria-hidden="true"></i>'
                ],
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1200: {
                        items: 3,
                        nav:true
                    }
                }
            });
        },
    });
}

const getInvitedJobs = (url, active_invitation_id) => {

    $.ajax({
        url: url,
        type: 'get',
        success: response => {
            if(response.success) {
                $('#hs_invited_jobs').html(response.content)
                initInviteOwl(active_invitation_id);
            }
        }
    });
}

function initInviteOwl(active_invitation_id) {
    let active_index = 0;
    if(active_invitation_id){
        $('#hs_invited_jobs').find('.inv_job_item').each(function(index, value){
            if($(value).attr('data-invitation_id') == active_invitation_id){
                active_index = index;
            }
        })
    }
    $.when($('#hs_job_carousel').owlCarousel({
        margin:10,
        autoplay: false,
        dots: false,
        nav: true,
        items: 1,
        startPosition: active_index,
        navText: [
            '<i class="fa fa-angle-left hs_carousel_nav"></i>',
            '<i class="fa fa-angle-right hs_carousel_nav"></i>'
        ]
    })
    ).done(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('apply_via_changed_cv') && urlParams.get('apply_via_changed_cv') === '1'
            || urlParams.has('slug') && urlParams.has('loginUser') && urlParams.get('loginUser') === '1') {
            setTimeout(function(){
                $('#hs_job_carousel').find('.owl-item.active .apply_button').trigger('click');
            }, 500);
        }
        else if($('#hs_job_carousel').find('.owl-item.active .load_question_form').length) {
            setTimeout(function () {
                $('#hs_job_carousel').find('.owl-item.active .load_question_form').trigger('click');
            }, 500);
        }
    })
}

function confirmReject(id, url, status) {

    $.ajax({
        url: url,
        type: 'post',
        data: {status: status, id: id},
        success: function (response) {
            var type = 'error';
            if(response.success) {
                type = 'success';
            }
            if(response.message) {
                showNotification(response.message, type);
            }

            $('#hs_default_modal').modal('hide')
            $('.invited_job_list_item[data-id='+id+']').remove();
        }
    });

}

const reloadParentWindow = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('from_invitation_apply')){
        const invitation_id = urlParams.get('from_invitation_apply');
        if(window.opener){
            let opener = window.opener;
            const openerUrl = opener.location.href;
            const openerUrlWithoutQuery = openerUrl.split('?')[0];
            let openerUrlParams = new URLSearchParams(opener.location.search);
            openerUrlParams.delete('userId');
            openerUrlParams.delete('loginUser');
            openerUrlParams.set('apply_via_changed_cv', '1');
            openerUrlParams.set('invitation_id', invitation_id);
            opener.location.href = openerUrlWithoutQuery + '?' + openerUrlParams.toString();
        }
    }
}

const updateInvitationSeen = (url) => {
    $.ajax({
        url: url,
        success: response => {
            if(response.success) {
                let element = $('#job_training_tab').find('.notify_count');
                if(element.length) {
                    element.remove();
                }
            }
        }
    });
}
